import React, { useContext } from "react";
import { contextapi } from "../../helpers/contextapi";
import { FaUserGraduate, FaEnvelope, FaBell } from "react-icons/fa";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader";
import "./StudentProfile.css";
import { Link } from "react-router-dom";
import { axiosget } from "../../helpers/httprequest";

const StudentBasic = () => {
  const context = useContext(contextapi);
  const { firstname, middlename, lastname, emailaddress, level, semester, photo, studentid } = context?.values?.student;

  return (
    <div className="student-profile-container">
      {/* Profile Card */}
      <div className="profile-card">
        <div className="profile-header">
          <div className="avatar-container">
            <img
              src={photo?.link || "https://ui-avatars.com/api/?name=" + encodeURIComponent(firstname + " " + lastname)}
              alt={`${firstname} ${lastname}`}
              className="profile-avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://ui-avatars.com/api/?name=" + encodeURIComponent(firstname + " " + lastname);
              }}
            />
            <span className="online-status"></span>
          </div>
        </div>

        <div className="profile-content-dashboard">
          <h2 className="student-name">
            {firstname} {middlename} {lastname}
          </h2>
          <p className="student-id">{studentid}</p>

          <div className="profile-details-dashboard">
            <div className="detail-item">
              <FaUserGraduate className="detail-icon" />
              <div>
                <span className="detail-label">Level & Semester</span>
                <span className="detail-value">
                  {level} • {semester}
                </span>
              </div>
            </div>

            <div className="detail-item">
              <FaEnvelope className="detail-icon" />
              <div>
                <span className="detail-label">Email</span>
                <span className="detail-value">{emailaddress}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notifications Section */}
      <NotificationSection />
    </div>
  );
};

const NotificationSection = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["studentNotifications"],
    queryFn: async () => {
      const req = await axiosget(`ms_notification/dash`);
      // // Replace with actual API call
      return req?.data;
    },
  });

  const formatDate = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffInHours = Math.floor((now - date) / 3600000);

    if (diffInHours < 24) {
      return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      return `${diffInDays} ${diffInDays === 1 ? "day" : "days"} ago`;
    }
  };

  const unreadCount = data?.filter((n) => !n.read).length || 0;

  return (
    <div className="notifications-panel">
      <div className="notifications-header">
        <div className="header-left">
          <FaBell className="bell-icon" />
          <h3>Notifications</h3>
          {unreadCount > 0 && <span className="unread-count">{unreadCount}</span>}
        </div>
        <Link to={`/app/notifications`} className="mark-all-btn">
          View All
        </Link>
      </div>

      {isLoading ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : (
        <div className="notifications-list">
          {data?.length > 0 ? (
            data
              ?.slice(0, 7)
              .map((notification, i) => <NotificationItem key={notification._id} notification={notification} i={i + 1} formatDate={formatDate} />)
          ) : (
            <div className="empty-state">
              <p>No notifications available</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const NotificationItem = ({ notification, i, formatDate }) => {
  console.log(notification);
  const [expanded, setExpanded] = React.useState(false);
  const { firstname, middlename, lastname } = notification?.staff;
  return (
    <div className={`notification-item`} onClick={() => setExpanded(!expanded)}>
      <div className="notification-avatar">{firstname.charAt(0)}</div>
      <div className="notification-content">
        <div className="notification-header">
          <h4 className="notification-title">Notification {i}</h4>
          <span className="notification-time">{formatDate(notification.createdAt)}</span>
        </div>
        <div className="notification-meta">
          <span className="course-name">{notification?.course?.code}</span>
          <span className="lecturer-name">
            {firstname} {middlename} {lastname}
          </span>
        </div>
        {expanded && <p className="notification-message">{notification.post}</p>}
      </div>
    </div>
  );
};

export default StudentBasic;
